import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { UrlPath } from "../../../../config/routeConfig";
import { getUniverseMembersAction } from "../../../actions/universeMembers";
import { getUniverseListAction } from "../../../actions/universeListAction";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../../shared/topBar/TopBar";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import Form from 'react-bootstrap/Form';
import "./UniverseEdit.css";
import { UniverseInsertorUpdate, deleteUniverse } from "../../../../config/apiConfig";
import { GetAllGlobalEntities } from "../../../actions/globalSearchAction";
import { ToastContainer, toast } from 'react-toastify';
import { SBATextBox } from "../../../UiComponents/SBATextBox";
import { sbaAxios } from "../../../utils/sbaAxios";
import { Modal } from 'react-bootstrap';
import { CustomNoRowsOverlay } from "../../../UiComponents/CustomNoRowsOverlay ";
export const UniverseDetailsEdit = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const TotalInvestmentApi = useRef();
    const selectedMembersApi = useRef();
    const history = useNavigate();
    const UniverseID = params.UniverseId;

    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;

    const memberDetails = Gstate.AnalyticsReporting.memberList.UniverseMemberDetails;
    const UniverseMembers = Gstate.AnalyticsReporting.memberList || [];
    const universeList = Gstate.AnalyticsReporting.universeList || [];
    const universeListLoading = Gstate.AnalyticsReporting.universeListLoading;


    const benchmarkEntities = Gstate.AllEntities.AllEntities;
    const availableBenchmarkLoading=Gstate.AllEntities.isLoading;
    const [isAvailableBenchmarkLoading,setIsAvailableBenchmarkLoading]=useState(availableBenchmarkLoading);
    const [selectedUniverse, setSelectedUniverse] = useState(UniverseMembers);
    const [universeID, setUniverseID] = useState(UniverseID);
    const [render, setRender] = useState(0);
    const [availableInvestment, setAvailableInvestment] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [selectedUniverseName, setSelectedUniverseName] = useState(selectedUniverse?.UniverseName);
    const [selectedDescription, setSelectedDescription] = useState(selectedUniverse.UniverseDescription ? selectedUniverse.UniverseDescription : null);
    const [newMembers, setNewMembers] = useState([]);
    const membersloading = useSelector((state) => state.AnalyticsReporting.memberDetailsLoading);
    const [universenametrim, setuniversenametrim] = useState();
    const [universedescr, setuniversedescr] = useState();
    const [showdeleteModal, setshowDeleteModal] = useState(false);
    const [showsaveasModal, setshowsaveasModal] = useState(false);
    const [selectedNewUniverseName, setselectedNewUniverseName] = useState();
    useEffect(() => {
        dispatch(getUniverseMembersAction(UniverseID));
      //  dispatch(getUniverseListAction());
    }, []);
    useEffect(() => {
        setSelectedUniverse(UniverseMembers);
    }, [UniverseMembers]);
    useEffect(()=>{
        setIsAvailableBenchmarkLoading(availableBenchmarkLoading);
    },[availableBenchmarkLoading])


    const defaultColDef = {
        flex: 1,resizable:true
    }

    useEffect(() => {
        setSelectedMembers(memberDetails?.map((item, index) => {
            return { ...item, "rowIndex": index + 1, OrderId: item.OrderId, MemberEntityId: item.MemberEntityId, MemberEntityTypeId: item.MemberEntityTypeId, UniverseId: parseInt(params.MemberId) }
        }));
    }, [memberDetails]);
    useEffect(() => {
        setSelectedUniverseName(selectedUniverse?.UniverseName)
    }, [selectedUniverse])
    //  search text onchange
    const useDebouncedCallback = (callback, delay) => {
        const [timer, setTimer] = useState(null);

        const debouncedCallback = useCallback((...args) => {
            if (timer) {
                clearTimeout(timer);
            }
            const newTimer = setTimeout(() => {
                callback(...args);
            }, delay);
            setTimer(newTimer);
        }, [callback, delay, timer]);

        return debouncedCallback;
    };
    const [searchTerm, setSearchTerm] = useState("");
    // const [membersloadings, setmembersloadings] = useState(false);
    const searchEntities = (search) => {
        if (search.length > 2) {
            dispatch(GetAllGlobalEntities(search, "true"));
        } else if (search.length === 0) {
            setAvailableInvestment([]);
        }
    } // Adjust debounce delay as needed

    useEffect(() => {
        if (searchTerm.length > 2) {
            setAvailableInvestment(benchmarkEntities);
        } else if (searchTerm.length === 0) {
            setAvailableInvestment([]);
        }
       
    }, [benchmarkEntities]);

    useEffect(()=>{
        if(isAvailableBenchmarkLoading)
            TotalInvestmentApi?.current?.api?.showLoadingOverlay();
    },[isAvailableBenchmarkLoading]);

    const changeSearchTerm = (e) => {
        const search = e.target.value.trim();
        setSearchTerm(search);
        searchEntities(search);
    };

    //--- Left side  grid col def start--

    const startDatevalueFormatter = (props) => {
        const date = props.data.StartDate;
        let monthName = "";
        let year = "";
        let convertedDate;
        let outPut = "";
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        if (date !== null) {
            convertedDate = new Date(date);
            monthName = monthNames[convertedDate.getMonth()];
            year = convertedDate.getFullYear();
            outPut = monthName + "-" + year;
        }
        return (
            <div>{outPut
            }</div>
        );
    };
    const endDatevalueFormatter = (props) => {
        const date = props.data.EndDate;
        let monthName = "";
        let year = "";
        let convertedDate;
        let outPut = "";
        const monthNames = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        if (date !== null) {
            convertedDate = new Date(date);
            monthName = monthNames[convertedDate.getMonth()];
            year = convertedDate.getFullYear();
            outPut = monthName + "-" + year;
        }
        return (
            <div>{outPut
            }</div>
        );
    };

    const AvailablecolDef = [
        { field: "EntityName", headerName: "Name", resizable: true },
        { field: "EntityTypeName", headerName: "Entity Type" },
        { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter },
        { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
    ];
    //--- Left side  grid col def End--

    //--- Right side Members grid col def start--
    const getDateFormatted = (params) => {
        const isoDate = params.value;
        const formattedDate = moment(isoDate).format('MM-DD-YYYY');
        return formattedDate;
    };

    const columnDefs = [
        { rowDrag: true, field: "MemberName", headerName: "Investment" },
        { field: "MemberEntityTypeName", headerName: "Entity", width: 100, },
        { field: "ReturnStartDate", headerName: "Return Start Date", cellRenderer: getDateFormatted },
        { field: "ReturnEndDate", headerName: "Return End Date", cellRenderer: getDateFormatted }
    ];
    //--- Right side Members grid col def End--

    //-Add Selected Members
    const addMembers = (e) => {

        const members = TotalInvestmentApi.current.api.getSelectedRows()[0];
        let errorMsg = [];
        if (members === undefined) {
            let ErrorString = "";
            errorMsg.push("Please select at least one universe member");
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });

            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
        members && addSelectedMembers(members);
    }
    const addSelectedMembers = (newInvestment) => {
        const newInvestmentEntityID = newInvestment.EntityId;
        if (!(selectedMembers.filter(item => item.MemberEntityId === newInvestmentEntityID && item.EntityTypeId === newInvestment.EntityTypeId).length > 0)) {
            if (newInvestment.EntityTypeId !== 2 && newInvestment.EntityTypeId !== 5) {
                const toAdd = {
                    'rowIndex': selectedMembers.length,
                    "MemberEntityId": newInvestment.EntityId,
                    "MemberName": newInvestment.EntityName,
                    "MemberEntityTypeId": newInvestment.EntityTypeId,
                    "MemberEntityTypeName": newInvestment.EntityTypeName,
                    "OrderId": selectedMembers.length + 1,
                    "ReturnStartDate": newInvestment.StartDate,
                    "ReturnEndDate": newInvestment.EndDate
                };
                setSelectedMembers((pv) => { return [...pv, { ...toAdd }] });
            }
        }
        else {
            toast.error("Selected Investment already Exist", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })

        }




    }


    //-Remove Selected Members

    const removeMembers = () => {
        const members = selectedMembersApi.current.api.getSelectedRows()[0];
        members && removeSelectedMembers(members);
    }
    const removeSelectedMembers = (investment) => {
        setSelectedMembers(pv => ((pv.filter(item => item.rowIndex !== investment.rowIndex).map((item, index) => { return { ...item, rowIndex: index, SortOrder: index } }))));
    }

    // Cancel button click --
    const CancelButtonClick = () => {
        history(`${UrlPath.UniverseMembers}${universeID}`);
    };

    //-- Name onchange
    const UniverseNameChange = (event) => {
        const result = SBATextBox(event.target.value)
        setuniversenametrim(result);
        setSelectedUniverseName(event.target.value);
    };

    //--Description onchange
    const DescriptionChange = (event) => {
        const result = SBATextBox(event.target.value)
        setuniversedescr(result);
        setSelectedDescription(event.target.value);
    };

    //-- Edit  Universe Details--
    const editUniverseDetails = (event) => {
        const rows = selectedMembers?.map((item, index) => {
            return { "memberEntityId": item.MemberEntityId, "memberEntityTypeId": item.MemberEntityTypeId, "orderId": item.OrderId }
        })
        event.preventDefault();
        let saveSuccess = true;
        let errorMsg = [];
        // Prepare the data to be sent in the POST request
        const data = {
            "UniverseId": UniverseID,
            "UniverseName": selectedUniverseName,
            "UniverseDescription": selectedDescription,
            "UniverseMembers": rows,
            "ModifiedBy": 0
        };
        if ((universenametrim === false) || (selectedUniverseName.length === 0)) {
            saveSuccess = false;
            errorMsg.push("Please Enter Universe Name");
        }
        if (rows.length === 0) {
            saveSuccess = false;
            errorMsg.push("Please select at least one universe member");
        }
        if (saveSuccess) {

            sbaAxios({
                url: `${UniverseInsertorUpdate}`,
                method: 'post',
                data: data,
            })
                .then((response) => {
                    if (response === -999) {

                        saveSuccess = false;
                        errorMsg.push("Universe Name already exsist");
                        let ErrorString = "";
                        errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
                        console.log(errorMsg);
                        toast.error(ErrorString, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                    }
                    else {
                        toast.success('Universe Updated Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        setTimeout(() => {
                            dispatch(getUniverseMembersAction(UniverseID));
                            history(`${UrlPath.UniverseMembers}${UniverseID}`);
                        }, 1000);
                    }
                })

                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            let ErrorString = "";
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
            console.log(errorMsg);
            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    };

    // Row Drag
    const handleRowDragEnd = (params) => {
        const rows = [];
        selectedMembersApi.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
        setSelectedMembers(rows?.map((item, index) => {
            return { ...item, "rowIndex": index + 1, OrderId: index + 1, MemberEntityId: item.MemberEntityId, MemberEntityTypeId: item.MemberEntityTypeId, UniverseId: parseInt(params.MemberId) }
        }));

        //  setSelectedMembers(rows);
    };

    const SMRowDoubleClick = (row) => {
        removeSelectedMembers(row.data);
    };
    const AMRowDoubleClick = (row) => {
        addSelectedMembers(row.data);
    };
    // Delete Universe
    const DeleteModalShow = () => {
        setshowDeleteModal(true);
    }

    const DeleteUniverse = () => {
        sbaAxios({
            url: `${deleteUniverse}${params.UniverseId}`,
            method: 'get',
        }).then((response) => {

            setTimeout(() => {
                setshowDeleteModal(false);
                toast.success('Universe Deleted Successfully', {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })


                history(`${UrlPath.UniverseList}`);


            }, 100);
        })
            .catch(error => {
                console.error('Error deleting data:', error);
            });
    }
    const closedeleteModal = () => {
        setshowDeleteModal(false);
    }

    {/* Save as */ }
    //-- Name onchange
    const newUniverseNameChange = (event) => {
        const result = SBATextBox(event.target.value)
        setuniversenametrim(result);
        setselectedNewUniverseName(event.target.value);
    };


    const saveasUniverseModal = () => {
        setshowsaveasModal(true);
    }

    const Saveuniverse = (event) => {
        const rows = selectedMembers?.map((item, index) => {
            return { "memberEntityId": item.MemberEntityId, "memberEntityTypeId": item.MemberEntityTypeId, "orderId": item.OrderId }
        })
        event.preventDefault();
        let saveSuccess = true;
        let errorMsg = [];
        // Prepare the data to be sent in the POST request
        const data = {
            "UniverseId": 0,
            "UniverseName": selectedNewUniverseName,
            "UniverseDescription": selectedDescription,
            "UniverseMembers": rows,
            "ModifiedBy": 0
        };
        if ((universenametrim === false) || (!selectedNewUniverseName)) {
            saveSuccess = false;
            errorMsg.push("Please Enter Universe Name");
        }
        if (rows.length === 0) {
            saveSuccess = false;
            errorMsg.push("Please select at least one universe member");
        }
        if (saveSuccess) {

            sbaAxios({
                url: `${UniverseInsertorUpdate}`,
                method: 'post',
                data: data,
            })
                .then((response) => {
                    if (response === -999) {

                        saveSuccess = false;
                        errorMsg.push("Universe Name already exsist");
                        let ErrorString = "";
                        errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
                        console.log(errorMsg);
                        toast.error(ErrorString, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                    }
                    else {
                        toast.success('Universe Updated Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        setTimeout(() => {
                            history(`${UrlPath.UniverseMembers}${response}`);
                        }, 1000);
                    }
                })

                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            let ErrorString = "";
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
            console.log(errorMsg);
            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }
    const closesaveasModal = () => {
        setshowsaveasModal(false);
    }

    const Level = [{ BreadCrumb: "Universe List >", Routes: `${UrlPath.UniverseList}` }, { BreadCrumb: `${selectedUniverse?.UniverseName} >`, Routes: `${UrlPath.UniverseMembers}${UniverseID}` }, { BreadCrumb: `Universe Edit`, Routes: `${UrlPath.UniverseEdit}${UniverseID}` }]
    return (<>  {universeListLoading ? <><LoadingScreen /></> : <div>
        <TopBar label={"Universe Edit"} />
        <BreadCrumbs Levels={Level} />
        <div id="Universeedit" className='container-fluid px-3'>
            <div className='headingGroup d-flex flex-column'>
                <div className='lineDiv'>
                    <label id="WarningLabel"></label>
                </div>
                <div className='row my-1'>
                    <div className="col-md-3 pe-0" style={{ marginRight: "0" }}>
                        <label className='label'>Universe Name<span className="mandatory">*</span></label>
                        <div>
                            <input
                                className="form-control w-100"
                                type="text"
                                defaultValue={selectedUniverse?.UniverseName}
                                onChange={UniverseNameChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="col-md-3 pe-0" style={{ marginLeft: "10%" }}>
                        <label className='label'>Description</label>
                        <div>
                            <textarea id="txtStrategydesc" className="form-control" rows={2}
                                defaultValue={selectedUniverse?.UniverseDescription} onChange={DescriptionChange} ></textarea>
                        </div>
                    </div>

                    <div className="col-md-4 pe-0">
                        <div className="col-md-12 text-end" style={{ marginLeft: "20%" }}>
                            <button className='p-sm-btn mx-1' onClick={editUniverseDetails} disabled={!isEditable}>Save</button>
                            <button className='p-sm-btn mx-1' onClick={saveasUniverseModal} disabled={!isEditable}>Save as New</button>
                            <button className='p-sm-btn mx-1' onClick={DeleteModalShow} disabled={!isEditable}>Delete</button>
                            <button className="s-sm-btn mx-1" onClick={CancelButtonClick}> Cancel</button>
                        </div>
                    </div>

                </div>
                <div className='d-flex flex-column lineDiv my-1'>
                    <div className="row px-0 mx-0">
                        <div className="col-md-3 px-0">
                            <label className='label'>Entity</label>
                            <div>
                                <Form.Control type="text" placeholder="Please Search Entity" onKeyUp={changeSearchTerm} className='w-100 flex-grow-1 input-default' />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </div>
            <div className='gridcontent d-flex flex-row mt-3' >
                <div className='gridDiv' >
                    <div>Available Investments</div>
                    <div className="griddata ag-theme-alpine" style={{ height: '35rem' }}>
                            <AgGridReact
                                    defaultColDef={defaultColDef}
                                    columnDefs={AvailablecolDef}
                                    rowData={availableInvestment}
                                    rowSelection={'single'}
                                    ref={TotalInvestmentApi}
                                    onRowDoubleClicked={AMRowDoubleClick}
                                    noRowsOverlayComponent={CustomNoRowsOverlay}
                                    overlayLoadingTemplate={'<div class="Loader"><div id="loading"><div><span style="--i: 1;"></span><span style="--i: 2;"></span><span style="--i: 3;"></span><span style="--i: 4;"></span><span style="--i: 5;"></span><span style="--i: 6;"></span><span style="--i: 7;"></span><span style="--i: 8;"></span><span style="--i: 9;"></span><span style="--i: 10;"></span></div></div></div>'}

                            />
                    </div>
                </div>
                <div className='d-flex flex-column justify-content-center px-3'>
                    <button className='p-sm-btn my-1' onClick={addMembers}>
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                    <button className='p-sm-btn my-1' onClick={removeMembers}>
                        <i class="fa-solid fa-arrow-left"></i>
                    </button>

                </div>
                <div className='gridDiv'>
                    <div>
                        Selected Investments
                    </div>
                    {membersloading ? (
                        <LoadingScreen />
                    ) : (
                        <>
                            <div className='griddata ag-theme-alpine' style={{ height: '35rem' }}>
                                <AgGridReact
                                    defaultColDef={defaultColDef}
                                    columnDefs={columnDefs}
                                    rowSelection={'single'}
                                    rowData={selectedMembers}
                                    ref={selectedMembersApi}
                                    rowDragManaged={true}
                                    suppressMoveWhenRowDragging={true}
                                    animateRows={true}
                                    onRowDragEnd={handleRowDragEnd}
                                    allowContextMenuWithControlKey={true}
                                    onRowDoubleClicked={SMRowDoubleClick}
                                ></AgGridReact>
                            </div>
                        </>
                    )

                    }
                </div>
            </div>
        </div>
        <Modal show={showdeleteModal}  >
            <Modal.Header closeButton onClick={closedeleteModal}>
                <Modal.Title>Do you want to delete the  Universe?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The Universe will be deleted permanently. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closedeleteModal} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={DeleteUniverse} >
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
        {/* Save As Modal.. */}
        <Modal show={showsaveasModal}  >
            <Modal.Header closeButton onClick={closesaveasModal}>
                <Modal.Title>Save As New Universe</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div >
                    <div>
                        <label className="label d-block">Universe Name</label>
                        <div className="value-spacing">{selectedUniverse?.UniverseName}</div>
                    </div>
                    <div>
                        <label className='label'>New Universe Name<span className="mandatory">*</span></label>
                        <div>
                            <input
                                className="form-control w-75"
                                type="text"
                                onChange={newUniverseNameChange}
                                required
                            />
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closesaveasModal} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={Saveuniverse} >
                    Save
                </button>
            </Modal.Footer>
        </Modal>
        <ToastContainer></ToastContainer>
    </div>}</>
    )

}